<app-header [transparent]="transparent" />
<div class="event_details">
    <div class="p-top-143 p-bot-16 p-x-100-res bg_1">
        <span>
            <a class="text_decoration_none text_blue_5" routerLink="/">
                Home
            </a>
        </span>
        <span class="p-x-16">
            <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.31367 7.85721L6.7222 4.44452C6.80933 4.38951 6.87927 4.32127 6.92722 4.24449C6.97517 4.1677 7 4.08419 7 3.99968C7 3.91517 6.97517 3.83165 6.92722 3.75487C6.87927 3.67809 6.80933 3.60985 6.7222 3.55484L1.31367 0.142143C0.797419 -0.18355 0 0.0864778 0 0.58698L0 7.41335C0 7.91386 0.797419 8.18388 1.31367 7.85721Z"
                    fill="#303030" />
            </svg>
        </span>
        <span class="text_blue_5">
            <a class="text_decoration_none text_blue_5" routerLink="/events">
                Our Events
            </a>
        </span>
        <span class="p-x-16">
            <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.31367 7.85721L6.7222 4.44452C6.80933 4.38951 6.87927 4.32127 6.92722 4.24449C6.97517 4.1677 7 4.08419 7 3.99968C7 3.91517 6.97517 3.83165 6.92722 3.75487C6.87927 3.67809 6.80933 3.60985 6.7222 3.55484L1.31367 0.142143C0.797419 -0.18355 0 0.0864778 0 0.58698L0 7.41335C0 7.91386 0.797419 8.18388 1.31367 7.85721Z"
                    fill="#303030" />
            </svg>
        </span>
        <span class="text_black_8">Event Detail</span>
    </div>
    <div class="event_details_body p-top-60 p-x-100-res p-b-90 bg_2">
        <div class="event_details_body_left">
            <img *ngIf="event_details.event_poster" class="image_width3"
                [src]="getEventImageUrl(event_details.event_poster)" alt="poster" />
            <div class="p-top-40 text_black_7">
                {{event_details.event_name}}
            </div>
            <div class="p-top-24 text_style_9" [innerHtml]="event_details.description"></div>
            <div class="p-top-40 text_black_10">
                Event Photos
            </div>
            <div class="event_details_body_images">
                <ng-container *ngFor="let image of event_details.
                event_images
                ">
                    <div class="event_details_body_images_item p-top-24">
                        <img class="width-100-per" [src]="getEventImageUrl(image)" alt="event_image" />
                    </div>
                </ng-container>
            </div>
            <div class="p-top-40" *ngIf="event_details.key_points_description || event_details.key_points?.length">
                <div class="text_black_10">
                    Key Points Of This Event
                </div>
                <div class="text_style_9 p-top-24" *ngIf="event_details.key_points_description"
                    [innerHtml]="event_details.key_points_description"></div>
                <div class="p-top-8" *ngIf="event_details.key_points?.length">
                    <ng-container *ngFor="let point of event_details.key_points">
                        <div class="event_details_body_points p-top-16">
                            <div>
                                <img src="../../../assets/icons/tick_icon.png" />
                            </div>
                            <div>
                                {{point}}
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

        </div>
        <div class="event_details_body_right">
            <div class="event_details_body_right_logo dis-flex-2 bg_1 border-radius-10">
                <div class="event_details_body_right_logo_box bg_2 border-radius-10 dis-flex-2">
                    <img *ngIf="event_details.event_logo" class="width-100-per height-100-per"
                        [src]="getLogoImageUrl(event_details.event_logo)" alt="logo" />
                </div>
            </div>
            <div class="event_details_body_right_speakers p-top-40" *ngIf="event_details.speakers?.length">
                <div class="text_black_10">
                    Speakers
                </div>
                <ng-container *ngFor="let speaker of event_details.speakers">
                    <div class="event_details_body_right_speakers_box p-top-24">
                        <div class="event_details_body_right_speakers_box_img dis-flex-2 bg_1 border-radius-10">
                            <img *ngIf="speaker.speaker_image" class="width-90-per"
                                [src]="getEventImageUrl(speaker.speaker_image)" alt="{{speaker.speaker_name}}" />
                        </div>
                        <div class="p-l-20 dis-flex-7">
                            <div class="event_details_body_right_speakers_box_info">
                                <div class="text_blue_15">
                                    {{speaker.speaker_name}}
                                </div>
                                <div class="text_style_9">
                                    {{speaker.speaker_description}}
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>

            <!-- <div class="p-top-40" *ngIf="event_details.web_link">
                <span class="text_black_10">Weblink: </span>
                <a [href]="event_details.web_link" class="text_blue_14" target="_blank">
                    {{ event_details.web_link }}
                </a>
            </div>  -->
            <div *ngIf="event_details.web_link" class="p-top-12">
                <button type="button" class="rounded-pill text_white_1 button_blue_7"
                    (click)="openLink(event_details.web_link)"><span class="button_blue_1_text"> Weblink</span> <img
                        class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png" /></button>
            </div>
            <div class="p-top-40">
                <div class="text_black_10">
                    Event Details
                </div>
                <div class="p-top-24 text_style_9">
                    <span>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M11.9 2.1H11.2V0.7C11.2 0.514348 11.1263 0.336301 10.995 0.205025C10.8637 0.0737498 10.6857 0 10.5 0C10.3143 0 10.1363 0.0737498 10.005 0.205025C9.87375 0.336301 9.8 0.514348 9.8 0.7V2.1H4.2V0.7C4.2 0.514348 4.12625 0.336301 3.99497 0.205025C3.8637 0.0737498 3.68565 0 3.5 0C3.31435 0 3.1363 0.0737498 3.00503 0.205025C2.87375 0.336301 2.8 0.514348 2.8 0.7V2.1H2.1C1.54305 2.1 1.0089 2.32125 0.615076 2.71508C0.221249 3.1089 0 3.64305 0 4.2V4.9H14V4.2C14 3.64305 13.7788 3.1089 13.3849 2.71508C12.9911 2.32125 12.457 2.1 11.9 2.1Z"
                                fill="#0032A0" />
                            <path
                                d="M0 11.9C0 12.457 0.221249 12.9911 0.615076 13.385C1.0089 13.7788 1.54305 14 2.1 14H11.9C12.457 14 12.9911 13.7788 13.3849 13.385C13.7788 12.9911 14 12.457 14 11.9V6.30005H0V11.9Z"
                                fill="#0032A0" />
                        </svg>
                    </span>
                    <span class="p-l-10">
                        <!-- {{event_details.event_date}} {{event_details.month}} {{event_details.year}} -->
                        {{event_details.event_start_date | date:'dd MMM yyyy'}} - {{event_details.event_end_date |
                        date:'dd MMM yyyy'}}

                    </span>
                </div>
                <div class="p-top-24 text_style_9">
                    <span>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_514_22471)">
                                <path
                                    d="M7 0C3.14005 0 0 3.14005 0 7C0 10.86 3.14005 14 7 14C10.86 14 14 10.86 14 7C14 3.14005 10.86 0 7 0ZM10.3291 10.6207C10.2153 10.7345 10.066 10.7917 9.9167 10.7917C9.76738 10.7917 9.61795 10.7345 9.5043 10.6207L6.5876 7.7041C6.47791 7.59505 6.4167 7.44679 6.4167 7.2917V3.5C6.4167 3.17743 6.67796 2.9167 7 2.9167C7.32204 2.9167 7.5833 3.17743 7.5833 3.5V7.0502L10.3291 9.7959C10.5571 10.024 10.5571 10.3927 10.3291 10.6207Z"
                                    fill="#0032A0" />
                            </g>
                            <defs>
                                <clipPath id="clip0_514_22471">
                                    <rect width="14" height="14" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </span>
                    <span class="p-l-10">
                        {{event_details.event_start_time}} - {{event_details.event_end_time}}
                    </span>
                </div>
                <div class="p-top-24 text_style_9">
                    <span>
                        <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M6 0C2.68811 0.00439329 0.0043933 2.68811 0 6C0 10.3075 5.59 15.7025 5.8275 15.93C5.92355 16.0233 6.07645 16.0233 6.1725 15.93C6.41 15.7025 12 10.3075 12 6C11.9956 2.68811 9.31189 0.00439329 6 0ZM6 8.75C4.48122 8.75 3.25 7.51877 3.25 5.99999C3.25 4.48121 4.48122 3.25 6 3.25C7.51878 3.25 8.75 4.48121 8.75 5.99999C8.74909 7.5184 7.51841 8.74908 6 8.75Z"
                                fill="#0032A0" />
                        </svg>
                    </span>
                    <span class="p-l-10">
                        {{event_details.event_address}}
                    </span>
                </div>
                <div class="share-buttons" style="margin-top:15px;">
                    <button (click)="copyLink()" style="background: transparent; border: none; cursor: pointer;">
                        <i class="fas fa-link" style="color: #000;"></i> <!-- Copy Link -->
                    </button>
                    <button (click)="shareViaEmail()" style="background: transparent; border: none; cursor: pointer;">
                        <i class="fas fa-envelope" style="color: #EA4335;"></i> <!-- Email -->
                    </button>
                    <button (click)="shareViaSMS()" style="background: transparent; border: none; cursor: pointer;">
                        <i class="fas fa-sms" style="color: #25D366;"></i> <!-- SMS -->
                    </button>
                    <button (click)="shareViaWhatsApp()"
                        style="background: transparent; border: none; cursor: pointer;">
                        <i class="fab fa-whatsapp" style="color: #25D366;"></i> <!-- WhatsApp -->
                    </button>
                    <button (click)="shareViaMessenger()"
                        style="background: transparent; border: none; cursor: pointer;">
                        <i class="fab fa-facebook-messenger" style="color: #0084FF;"></i> <!-- Messenger -->
                    </button>
                    <button (click)="shareViaViber()" style="background: transparent; border: none; cursor: pointer;">
                        <i class="fab fa-viber" style="color: #59267C;"></i> <!-- Viber -->
                    </button>
                    <button (click)="shareViaFacebook()"
                        style="background: transparent; border: none; cursor: pointer;">
                        <i class="fab fa-facebook" style="color: #4267B2;"></i> <!-- Facebook -->
                    </button>
                    <button (click)="shareViaTwitter()" style="background: transparent; border: none; cursor: pointer;">
                        <i class="fab fa-twitter" style="color: #1DA1F2;"></i> <!-- Twitter -->
                    </button>
                    <button (click)="shareViaLinkedIn()"
                        style="background: transparent; border: none; cursor: pointer;">
                        <i class="fab fa-linkedin" style="color: #0077B5;"></i> <!-- LinkedIn -->
                    </button>
                    <button (click)="shareViaPinterest()"
                        style="background: transparent; border: none; cursor: pointer;">
                        <i class="fab fa-pinterest" style="color: #E60023;"></i> <!-- Pinterest -->
                    </button>
                    <button (click)="shareViaReddit()" style="background: transparent; border: none; cursor: pointer;">
                        <i class="fab fa-reddit" style="color: #FF4500;"></i> <!-- Reddit -->
                    </button>
                    <button (click)="shareViaTumblr()" style="background: transparent; border: none; cursor: pointer;">
                        <i class="fab fa-tumblr" style="color: #35465C;"></i> <!-- Tumblr -->
                    </button>
                    <button (click)="shareViaTelegram()"
                        style="background: transparent; border: none; cursor: pointer;">
                        <i class="fab fa-telegram" style="color: #0088CC;"></i> <!-- Telegram -->
                    </button>
                    <button (click)="shareViaVK()" style="background: transparent; border: none; cursor: pointer;">
                        <i class="fab fa-vk" style="color: #4B7BE5;"></i> <!-- VK -->
                    </button>
                    <button (click)="shareViaMix()" style="background: transparent; border: none; cursor: pointer;">
                        <i class="fab fa-mix" style="color: #00A3E0;"></i> <!-- Mix -->
                    </button>
                    <button (click)="shareViaXing()" style="background: transparent; border: none; cursor: pointer;">
                        <i class="fab fa-xing" style="color: #006567;"></i> <!-- Xing -->
                    </button>
                    <button (click)="shareViaLine()" style="background: transparent; border: none; cursor: pointer;">
                        <i class="fab fa-line" style="color: #00B900;"></i> <!-- Line -->
                    </button>

                </div>
            </div>
        </div>
    </div>

</div>
<app-footer />